import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VCard,
        [
          _c(VDataTable, {
            key: _vm.keySectionsTable,
            staticClass: "text-center table-inca",
            attrs: {
              responsive: "",
              hover: "",
              items: _vm.items,
              headers: _vm.headers,
              "hide-default-footer": "",
              "disable-pagination": "",
            },
            scopedSlots: _vm._u([
              {
                key: "item.actions",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c(
                      VTooltip,
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "btn-icon-inca",
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDeleteSection(
                                                item.section
                                              )
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_c(VIcon, [_vm._v("icon-delete")])],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [_c("span", [_vm._v("Eliminar sección")])]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("dialogs-component", {
        ref: _vm.DIALOG_ADD_SECTION,
        attrs: { title: "Añadir section", width: 900 },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              var this$1 = this
              return [
                _c(
                  VForm,
                  {
                    ref: "formAddSection",
                    staticClass: "form mt-2",
                    attrs: { "lazy-validation": "" },
                    model: {
                      value: _vm.valid,
                      callback: function ($$v) {
                        _vm.valid = $$v
                      },
                      expression: "valid",
                    },
                  },
                  [
                    _c(
                      VRow,
                      { attrs: { dense: "" } },
                      [
                        _c(
                          VCol,
                          { attrs: { cols: "3" } },
                          [
                            _c(
                              VSubheader,
                              { staticClass: "font-weight-bold" },
                              [_vm._v("Nombre")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          { attrs: { cols: "9" } },
                          [
                            _c(VTextField, {
                              attrs: {
                                outlined: "",
                                "hide-details": "auto",
                                dense: "",
                                rules: [
                                  function (v) {
                                    return (
                                      !!v || this$1.translate("reglas.field")
                                    )
                                  },
                                ],
                              },
                              model: {
                                value: _vm.sectionToAdd,
                                callback: function ($$v) {
                                  _vm.sectionToAdd = $$v
                                },
                                expression: "sectionToAdd",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.onAddSection($event)
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [
                      _vm._v("icon-send"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("common.add")) + " "),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }